// Flat-price editor: a single fixed dollar amount that applies regardless of
// area. Controlled — `amount` is a number and `onChange` receives the next
// number. Mirrors TieredPricingEditor's draft handling so a cleared field can
// stay empty while typing instead of snapping back to 0.
import { useState } from 'react';
import {
  Box, Typography, TextField, InputAdornment,
} from '@mui/material';

const FlatPriceEditor = ({ amount, onChange, label = 'Flat price' }) => {
  const [draft, setDraft] = useState(null);

  const handleChange = (event) => {
    const raw = event.target.value;
    setDraft(raw);
    onChange(raw === '' ? 0 : Number(raw));
  };

  let value;
  if (draft != null) value = draft;
  else value = Number.isFinite(amount) ? amount : 0;

  return (
    <Box>
      <Typography component="span" variant="subtitle2" sx={{ display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
        A single fixed price, charged the same for every area size.
      </Typography>
      <TextField
        type="number"
        size="small"
        label="Price"
        value={value}
        onChange={handleChange}
        onBlur={() => setDraft(null)}
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          },
          htmlInput: { min: 0, step: 1 },
        }}
      />
    </Box>
  );
};

export default FlatPriceEditor;
